module.exports = __webpack_public_path__ + "static/media/Noodelicious.e8d1fad1.png";